import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/TextHFour.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "TextHFourIcon";
const n = e;
export {
  n as TextHFour,
  e as TextHFourIcon
};
